import type * as React from 'react';
import { get } from '@Domain/Api';
import ApiError from '@Infra/FetchLib/ApiError';
import identityProviderFetched, {
	type IdentityProviderFetchedAction,
	type IdentityProviderPayload,
} from '@Application/Security/Sso/Actions/identityProviderFetched';
import identityProviderFetchFailed, {
	type IdentityProviderFetchFailedAction,
} from '@Application/Security/Sso/Actions/identityProviderFetchFailed';
import type FetchIdentityProvider from '@Application/Security/Sso/Queries/FetchIdentityProvider';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = IdentityProviderFetchedAction | IdentityProviderFetchFailedAction;

export default (query: FetchIdentityProvider) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<IdentityProviderPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/identity-provider`,
			);

			const action = identityProviderFetched({ identityProvider: payload }, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			if (error instanceof ApiError && error.status === 404) {
				// No configuration is the "SSO disabled" state, not a failure: the store must resolve to
				// `null` so the screen renders an empty state rather than looping on `useStoreQuery`'s `stopOn`.
				const action = identityProviderFetched({ identityProvider: null }, query.accountId);
				dispatch(action);
				return action;
			}

			const action = identityProviderFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
